export const validateStockUrl = (url) => {
  const trimmedUrl = url?.trim();
  
  if (!trimmedUrl) {
    return { isValid: false, message: "Please enter a URL" };
  }

  if (!trimmedUrl.startsWith("https://www.boursedirect.fr/")) {
    return { 
      isValid: false, 
      message: "URL must be from Bourse Direct (https://www.boursedirect.fr/)" 
    };
  }
  try {
    new URL(trimmedUrl);
  } catch {
    return { isValid: false, message: "Invalid URL format" };
  }
  
  // Check for minimum path segments
  const pathSegments = new URL(trimmedUrl).pathname.split('/');
  if (pathSegments.length < 5) {
    return { isValid: false, message: "URL appears incomplete" };
  }

  // Graphiques page check
  if (!trimmedUrl.endsWith('/graphiques')) {
    return {
      isValid: false,
      message: "URL must end with '/graphiques'"
    };
  }

  return { isValid: true };
};

// Optional: Export for direct use in forms
export const isUrlValid = (url) => validateStockUrl(url).isValid;